var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame290570(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.743164,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0028 14.4888L19.0899 10.4001C19.2999 10.1908 19.6394 10.1908 19.8292 10.4001C20.057 10.6094 20.057 10.9489 19.8292 11.1581L15.7599 15.2459L19.8292 19.3331C20.057 19.543 20.057 19.8825 19.8292 20.0723C19.6394 20.3001 19.2999 20.3001 19.0899 20.0723L15.0028 16.0031L10.915 20.0723C10.7058 20.3001 10.3663 20.3001 10.157 20.0723C9.94767 19.8825 9.94767 19.543 10.157 19.3331L14.2457 15.2459L10.157 11.1581C9.94767 10.9489 9.94767 10.6094 10.157 10.4001C10.3663 10.1908 10.7058 10.1908 10.915 10.4001L15.0028 14.4888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame290570);
export default __webpack_public_path__ + "static/media/frame-290570.abb410a1364237f5f2bf1ac84a517c32.svg";
export { ForwardRef as ReactComponent };